import { render, staticRenderFns } from "./ViewPartePage.vue?vue&type=template&id=471bf7dc&scoped=true"
import script from "./ViewPartePage.vue?vue&type=script&lang=js"
export * from "./ViewPartePage.vue?vue&type=script&lang=js"
import style0 from "./ViewPartePage.vue?vue&type=style&index=0&id=471bf7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471bf7dc",
  null
  
)

export default component.exports